<template>
  <div>
    <!--
  {{this.series}}***
  {{this.Item_Inputdata}}
    {{ this.ctrldataNew }}*****

    {{ this.datalist }}-->
    <apexchart
      height="400"
      type="bubble"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import apifactorynew from "../../api";
import VueApexCharts from "vue-apexcharts";
export default {
  components: { apexchart: VueApexCharts },
  name: "BubbleExample",
  props: {
    ctrldataNew: [],
  },
  data: function () {
    return {
      resultdatafromapi: [],
      tempctrldata: "",
      datalist: [],
      chartOptions: {
        chart: {
          type: "bubble",
          toolbar: {
            show: true,
          },
          fontFamily: "Lato",
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            distributed: true,
            barHeight: "50%",
            horizontal: true,
          },
          bubble: {
            // minBubbleRadius: 25,
            // maxBubbleRadius: 50,
          },
        },
        grid: {
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          show: true,
          title: {
            text: "ROI",
            style: {
              color: "#9AA1A9",
            },
          },
          type: "numeric",
          labels: {
            style: {
              colors: "#9AA1A9",
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: "Spend",
            style: {
              color: "#9AA1A9",
            },
          },
          labels: {
            style: {
              colors: ["#9AA1A9"],
            },
            formatter: (value) => new Intl.NumberFormat("en").format(value),
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        tooltip: {
          inverseOrder: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<div class='arrow_box' style='font-family: Lato'>" +
              "<div style='margin-bottom: 5px; font-weight: bold; background: #f3f5f8; padding: 10px; border-bottom: 1px solid lightgrey'>" +
              w.globals.seriesNames[seriesIndex] +
              "</div>" +
              "<div style='padding-left: 10px'>" +
              "ROI: " +
              "<span style='font-weight: bold'>" +
              w.globals.seriesX[seriesIndex][0] +
              "</span>" +
              "</div>" +
              "<div style='padding-left: 10px;padding-right: 10px; padding-top: 5px'>" +
              "Spend: " +
              "<span style='font-weight: bold'>" +
              new Intl.NumberFormat("en").format(
                series[seriesIndex][dataPointIndex]
              ) +
              "</span>" +
              "</div>" +
              "<div style='padding: 5px 10px 5px 10px'>" +
              "Volume Contribution: " +
              "<span style='font-weight: bold'>" +
              new Intl.NumberFormat("en").format(
                w.globals.seriesZ[seriesIndex][0]
              ) +
              "%</span>" +
              "</div>" +
              "</div>"
            );
          },
        },
      },
      series: [],
      seriesold: [],
      Item_Spend: [],
      Item_volume_contribution: [],
      Item_roi: [],
      Item_roi_activity12: [],
      Item_Inputdata: [],
    };
  },
  methods: {
    getdate() {
      // alert('load');
      this.callapidata();
    },
    callapidata() {
     
      this.series = [];
      this.resultdatafromapi = [];
      this.datalist = [];
      var tempdatalist = [];
      var alltempdata = [];
      var tempdatalist_roi = [];
      var tempdatalist_spend = [];
      var tempdatalist_volume_response = [];
      apifactorynew
        .get_model_outcome_str()
        .then((res) => {
          if (this.ctrldataNew == "Total Period") {
            this.resultdatafromapi = res.data.roi_total;
            alltempdata = res.data.roi_total;
          }
           if (this.ctrldataNew == "Current Period") {
            this.resultdatafromapi = res.data.roi_current;
            alltempdata = res.data.roi_current;
          }
           if (this.ctrldataNew == "Previous Period") {
            this.resultdatafromapi = res.data.roi_previous;
            alltempdata = res.data.roi_previous;
          }

          tempdatalist = alltempdata.variable;
          tempdatalist_roi = alltempdata.roi;
          tempdatalist_spend = alltempdata.spend;

          tempdatalist_volume_response = alltempdata.volume_response;
          for (var k1 in tempdatalist) {
            var objnew = new Object();
            objnew.name = tempdatalist[k1];

            let tempdataArray = [];
            var x = tempdatalist_roi[k1];
            var y = tempdatalist_spend[k1];
            var z = tempdatalist_volume_response[k1];

            tempdataArray.push([x, y, z]);
            objnew.data = tempdataArray;
            this.datalist.push(objnew);
          }
          
          this.series = this.datalist;
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    refresh() {
      this.getdate();
    },
  },
  mounted() {
    this.getdate();
    //this.binddata();
    //bus.$off("refreshChartBubbleNew");
    // alert('dd');
    //bus.$on("refreshChartBubbleNew", this.refresh);
  },
  computed: {
    options() {
      return {
        chart: {
          type: "bubble",
          toolbar: {
            show: true,
          },
          fontFamily: "Lato",
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            distributed: true,
            barHeight: "50%",
            horizontal: true,
          },
          bubble: {
            // minBubbleRadius: 25,
            // maxBubbleRadius: 50,
          },
        },
        grid: {
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          show: true,
          title: {
            text: "ROI",
            style: {
              color: "#9AA1A9",
            },
          },
          type: "numeric",
          labels: {
            style: {
              colors: "#9AA1A9",
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: "Spend",
            style: {
              color: "#9AA1A9",
            },
          },
          labels: {
            style: {
              colors: ["#9AA1A9"],
            },
            formatter: (value) => new Intl.NumberFormat("en").format(value),
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        tooltip: {
          inverseOrder: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<div class='arrow_box' style='font-family: Lato'>" +
              "<div style='margin-bottom: 5px; font-weight: bold; background: #f3f5f8; padding: 10px; border-bottom: 1px solid lightgrey'>" +
              w.globals.seriesNames[seriesIndex] +
              "</div>" +
              "<div style='padding-left: 10px'>" +
              "ROI: " +
              "<span style='font-weight: bold'>" +
              w.globals.seriesX[seriesIndex][0] +
              "</span>" +
              "</div>" +
              "<div style='padding-left: 10px; padding-top: 5px'>" +
              "Spend: " +
              "<span style='font-weight: bold'>" +
              new Intl.NumberFormat("en").format(
                series[seriesIndex][dataPointIndex]
              ) +
              "</span>" +
              "</div>" +
              "<div style='padding: 5px 10px 5px 10px'>" +
              "Volume Contribution: " +
              "<span style='font-weight: bold'>" +
              w.globals.seriesZ[seriesIndex][0] +
              "%" +
              "</span>" +
              "</div>" +
              "</div>"
            );
          },
        },
      };
    },
  },
  watch: {
    ctrldataNew: function (val) {
      //alert("Onoad -" + val);
      if (val) {
        this.tempctrldata = val;
        //this.getdate();
        this.refresh();
      }
    },
  },
};
</script>

<style scoped>
.notediv {
  text-align: left;
  font-weight: bold;
}

.headerboxtitle {
  font-size: 20px;
}

.card4 {
  background-color: #dc3545;
  color: white;
}
</style>
